import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateProductionLineMutationVariables = Types.Exact<{
  input: Types.CreateProductionLineInput;
}>;


export type CreateProductionLineMutation = { __typename?: 'Mutation', createProductionLine: { __typename?: 'ProductionLinePayload', productionLine?: { __typename?: 'ProductionLineStateData', productionLineId: string, tenantId: string, code: string, description: string, deviceIds: Array<string>, locationId?: string | null, activeCountSessionId?: string | null, status: Types.ProductionLineStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionLineMutationVariables = Types.Exact<{
  input: Types.UpdateProductionLineInput;
}>;


export type UpdateProductionLineMutation = { __typename?: 'Mutation', updateProductionLine: { __typename?: 'ProductionLinePayload', productionLine?: { __typename?: 'ProductionLineStateData', productionLineId: string, tenantId: string, code: string, description: string, deviceIds: Array<string>, locationId?: string | null, activeCountSessionId?: string | null, status: Types.ProductionLineStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StartCountSessionMutationVariables = Types.Exact<{
  input: Types.StartCountSessionInput;
}>;


export type StartCountSessionMutation = { __typename?: 'Mutation', startCountSession: { __typename?: 'CountSessionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PauseCountSessionMutationVariables = Types.Exact<{
  input: Types.PauseCountSessionInput;
}>;


export type PauseCountSessionMutation = { __typename?: 'Mutation', pauseCountSession: { __typename?: 'CountSessionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ResumeCountSessionMutationVariables = Types.Exact<{
  input: Types.ResumeCountSessionInput;
}>;


export type ResumeCountSessionMutation = { __typename?: 'Mutation', resumeCountSession: { __typename?: 'CountSessionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteCountSessionMutationVariables = Types.Exact<{
  input: Types.CompleteCountSessionInput;
}>;


export type CompleteCountSessionMutation = { __typename?: 'Mutation', completeCountSession: { __typename?: 'CountSessionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCountSessionTargetMutationVariables = Types.Exact<{
  input: Types.SetCountSessionTargetInput;
}>;


export type SetCountSessionTargetMutation = { __typename?: 'Mutation', setCountSessionTarget: { __typename?: 'CountSessionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelCountSessionMutationVariables = Types.Exact<{
  input: Types.CancelCountSessionInput;
}>;


export type CancelCountSessionMutation = { __typename?: 'Mutation', cancelCountSession: { __typename?: 'CountSessionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RegisterCountMutationVariables = Types.Exact<{
  input: Types.RegisterCountInput;
}>;


export type RegisterCountMutation = { __typename?: 'Mutation', registerCount: { __typename?: 'CountSessionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCountedQuantityMutationVariables = Types.Exact<{
  input: Types.SetCountedQuantityInput;
}>;


export type SetCountedQuantityMutation = { __typename?: 'Mutation', setCountedQuantity: { __typename?: 'CountSessionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CorrectCountedTotalMutationVariables = Types.Exact<{
  input: Types.CorrectCountedTotalInput;
}>;


export type CorrectCountedTotalMutation = { __typename?: 'Mutation', correctCountedTotal: { __typename?: 'CountCorrectionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, correction?: { __typename?: 'CountCorrectionRecord', correctionId: string, kind: Types.CountCorrectionKind, state: Types.CountCorrectionState, value: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AdjustCountedQuantityMutationVariables = Types.Exact<{
  input: Types.AdjustCountedQuantityInput;
}>;


export type AdjustCountedQuantityMutation = { __typename?: 'Mutation', adjustCountedQuantity: { __typename?: 'CountCorrectionPayload', countSession?: { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null } | null, correction?: { __typename?: 'CountCorrectionRecord', correctionId: string, kind: Types.CountCorrectionKind, state: Types.CountCorrectionState, value: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateProductionLineDocument = new TypedDocumentString(`
    mutation CreateProductionLine($input: CreateProductionLineInput!) {
  createProductionLine(input: $input) {
    productionLine {
      ...ProductionLineState
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLineState on ProductionLineStateData {
  productionLineId
  tenantId
  code
  description
  deviceIds
  locationId
  activeCountSessionId
  status
  createdAt
  updatedAt
}`);
export const UpdateProductionLineDocument = new TypedDocumentString(`
    mutation UpdateProductionLine($input: UpdateProductionLineInput!) {
  updateProductionLine(input: $input) {
    productionLine {
      ...ProductionLineState
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLineState on ProductionLineStateData {
  productionLineId
  tenantId
  code
  description
  deviceIds
  locationId
  activeCountSessionId
  status
  createdAt
  updatedAt
}`);
export const StartCountSessionDocument = new TypedDocumentString(`
    mutation StartCountSession($input: StartCountSessionInput!) {
  startCountSession(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const PauseCountSessionDocument = new TypedDocumentString(`
    mutation PauseCountSession($input: PauseCountSessionInput!) {
  pauseCountSession(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const ResumeCountSessionDocument = new TypedDocumentString(`
    mutation ResumeCountSession($input: ResumeCountSessionInput!) {
  resumeCountSession(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const CompleteCountSessionDocument = new TypedDocumentString(`
    mutation CompleteCountSession($input: CompleteCountSessionInput!) {
  completeCountSession(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const SetCountSessionTargetDocument = new TypedDocumentString(`
    mutation SetCountSessionTarget($input: SetCountSessionTargetInput!) {
  setCountSessionTarget(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const CancelCountSessionDocument = new TypedDocumentString(`
    mutation CancelCountSession($input: CancelCountSessionInput!) {
  cancelCountSession(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const RegisterCountDocument = new TypedDocumentString(`
    mutation RegisterCount($input: RegisterCountInput!) {
  registerCount(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const SetCountedQuantityDocument = new TypedDocumentString(`
    mutation SetCountedQuantity($input: SetCountedQuantityInput!) {
  setCountedQuantity(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const CorrectCountedTotalDocument = new TypedDocumentString(`
    mutation CorrectCountedTotal($input: CorrectCountedTotalInput!) {
  correctCountedTotal(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    correction {
      correctionId
      kind
      state
      value
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
export const AdjustCountedQuantityDocument = new TypedDocumentString(`
    mutation AdjustCountedQuantity($input: AdjustCountedQuantityInput!) {
  adjustCountedQuantity(input: $input) {
    countSession {
      ...CountSessionStartResult
    }
    correction {
      correctionId
      kind
      state
      value
    }
    errors {
      code
      message
    }
  }
}
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateProductionLine: build.mutation<CreateProductionLineMutation, CreateProductionLineMutationVariables>({
      query: (variables) => ({ document: CreateProductionLineDocument, variables })
    }),
    UpdateProductionLine: build.mutation<UpdateProductionLineMutation, UpdateProductionLineMutationVariables>({
      query: (variables) => ({ document: UpdateProductionLineDocument, variables })
    }),
    StartCountSession: build.mutation<StartCountSessionMutation, StartCountSessionMutationVariables>({
      query: (variables) => ({ document: StartCountSessionDocument, variables })
    }),
    PauseCountSession: build.mutation<PauseCountSessionMutation, PauseCountSessionMutationVariables>({
      query: (variables) => ({ document: PauseCountSessionDocument, variables })
    }),
    ResumeCountSession: build.mutation<ResumeCountSessionMutation, ResumeCountSessionMutationVariables>({
      query: (variables) => ({ document: ResumeCountSessionDocument, variables })
    }),
    CompleteCountSession: build.mutation<CompleteCountSessionMutation, CompleteCountSessionMutationVariables>({
      query: (variables) => ({ document: CompleteCountSessionDocument, variables })
    }),
    SetCountSessionTarget: build.mutation<SetCountSessionTargetMutation, SetCountSessionTargetMutationVariables>({
      query: (variables) => ({ document: SetCountSessionTargetDocument, variables })
    }),
    CancelCountSession: build.mutation<CancelCountSessionMutation, CancelCountSessionMutationVariables>({
      query: (variables) => ({ document: CancelCountSessionDocument, variables })
    }),
    RegisterCount: build.mutation<RegisterCountMutation, RegisterCountMutationVariables>({
      query: (variables) => ({ document: RegisterCountDocument, variables })
    }),
    SetCountedQuantity: build.mutation<SetCountedQuantityMutation, SetCountedQuantityMutationVariables>({
      query: (variables) => ({ document: SetCountedQuantityDocument, variables })
    }),
    CorrectCountedTotal: build.mutation<CorrectCountedTotalMutation, CorrectCountedTotalMutationVariables>({
      query: (variables) => ({ document: CorrectCountedTotalDocument, variables })
    }),
    AdjustCountedQuantity: build.mutation<AdjustCountedQuantityMutation, AdjustCountedQuantityMutationVariables>({
      query: (variables) => ({ document: AdjustCountedQuantityDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateProductionLineMutation, useUpdateProductionLineMutation, useStartCountSessionMutation, usePauseCountSessionMutation, useResumeCountSessionMutation, useCompleteCountSessionMutation, useSetCountSessionTargetMutation, useCancelCountSessionMutation, useRegisterCountMutation, useSetCountedQuantityMutation, useCorrectCountedTotalMutation, useAdjustCountedQuantityMutation } = injectedRtkApi;
